// Ensure the __webpack_public_path__ is configured correctly before any additional chunks are loaded
// If not done before any imports this will result in some chunks being loaded from the wrong location
// No other imports should be done before this point

const baseUrl = document.currentScript?.getAttribute('src')?.replace(/\/static\/js\/[^\\/]+$/, '/');
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
__webpack_public_path__ = baseUrl;

// MSAL silent token renewal loads the redirectUri in a hidden iframe. There we must only hand the
// auth response back to the main frame instead of booting the app (which fails with block_iframe_reload).
const authResponse = `${window.location.search}${window.location.hash}`;
const isMsalIframeRedirect = window !== window.parent && /[?#&]state=/.test(authResponse) && /[?#&](code|error)=/.test(authResponse);

if (isMsalIframeRedirect) {
  void import('@azure/msal-browser/redirect-bridge').then(({ broadcastResponseToMainFrame }) => broadcastResponseToMainFrame());
} else {
  void import(
    // Prevent any unnecessary chunk fetching roundtrips during microfrontend initialization
    // https://webpack.js.org/api/module-methods/#magic-comments
    /* webpackMode: "eager" */
    './bootstrap'
  );
}
